import "json2typescript";
//@JsonObject("UserModel")
export class UserModel {
    constructor() {
        //@JsonProperty("uuid", String)
        this.id = "";
        //@JsonProperty("email", String)
        this.email = "";
        //@JsonProperty("firstname", String)
        this.firstname = "";
        //@JsonProperty("middlename", String)
        this.middlename = "";
        //@JsonProperty("lastname", String)
        this.lastname = "";
        //@JsonProperty("photo", String)
        this.photo = "";
        //@JsonProperty("status", String)
        this.status = "";
        //@JsonProperty("type", String)
        this.type = "";
        //@JsonProperty("primaryBuilding", String)
        this.primaryBuilding = "";
        //@JsonProperty("primarySector", String)
        this.primarySector = "";
        this.devices = [];
    }
}
